import { useEffect } from 'react';

import { today, weekBeforeToday } from '@app/constants';

import type { UseOrganizationAnalyticsEffectsProps } from '../types';

export const useOrganizationAnalyticsEffects = ({
  fetchOrganizationsAnalytics,
}: UseOrganizationAnalyticsEffectsProps) => {
  useEffect(() => {
    fetchOrganizationsAnalytics({
      search: '',
      period: [weekBeforeToday, today],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
